import { Pipe, PipeTransform } from '@angular/core';
import { Inspection } from "../../classes/inspection";
import {User} from "../../classes/user";

@Pipe({
  name: 'inspectionInspectorFilter',
  pure: false
})
export class InspectionInspectorFilterPipe implements PipeTransform {

  transform(inspectionList: Array<Inspection>, filterValue: string, user: User): any {
    let inspectionFiltered;
    if (!inspectionList || !filterValue) {
      return inspectionList;
    }
    switch (filterValue) {
      case 'all':
        inspectionFiltered = inspectionList.filter((inspection: Inspection) =>
            (user.fk_id_role === 4) ? user.fk_id_pa === inspection.fk_id_pa : inspection.fk_id_user === user.id_user);
        break;

      case 'toDo':
        inspectionFiltered = inspectionList.filter((inspection: Inspection) =>
            inspection.fk_id_inspection_state === 4 && inspection.fk_id_user === user.id_user);
        break;

      case 'done':
        inspectionFiltered = inspectionList.filter((inspection: Inspection) =>
            inspection.fk_id_inspection_state === 5 && inspection.fk_id_user === user.id_user);
        break;

      case 'checked':
        inspectionFiltered = inspectionList.filter((inspection: Inspection) =>
            inspection.fk_id_inspection_state === 6 && inspection.fk_id_user === user.id_user);
        break;

      default:
        inspectionFiltered = inspectionList
        break;
    }

    return inspectionFiltered;
  }

}
